import styled from 'styled-components';
import bgDark from '@/assets/images/bg_dark.png';
import bgLight from '@/assets/images/bg_light.png';

export const MobileTradeModalView = styled.div<{ isDarkMode?: any }>`
  display: flex;
  flex-direction: column;
`;
export const TradeContainer = styled.div<{ $isDemoMode?: boolean }>`
  width: 100%;
  /* height: 130vh; */
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding: 0;
  background: ${({ theme, $isDemoMode }) => {
    if ($isDemoMode) {
      // 다크모드일 때는 진하고 깊은 청색 그라디언트로 구분
      // 라이트모드일 때는 아주 살짝 진한 민트색 그라디언트
      return theme.COLORS.bgColor === '#000'
        ? 'linear-gradient(135deg, #06182b 0%, #0a1f38 30%, #0e2947 60%, #133558 100%)' // 다크모드 - 진하고 깊은 청색 그라디언트
        : 'linear-gradient(135deg, #f0f9fa 0%, #e8f5f6 50%, #e0f2f4 100%)'; // 라이트모드 - 아주 살짝 진한 민트 그라디언트
    }
    return theme.body2;
  }};
  flex-grow: 1;
  transition: background 0.3s ease;
`;
export const ContentContainer = styled.div<{ isDarkMode?: any }>`
  width: 100%;
  min-height: 100vh;
  height: auto;
  /* height: 200vh; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.body};
  // background-image: url(${(props) => (props.isDarkMode ? bgLight : bgDark)});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
export const ContentWrapper = styled.div`
  width: 100%;
  display: block;
  /* flex: 1; */
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding: 0;
`;
export const ContentSplit = styled.div`
  width: 100%;
  height: auto;
  font-size: 1.4rem;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  position: relative;
`;

export const ContentLeft = styled.div`
  width: 80%;
  height: 60%;
  display: flex;
  flex-direction: row;
  @media (max-width: 1200px) {
    width: 100%;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    height: 70%;
  }
`;
export const ContentCenter = styled.div`
  width: 80%;
  height: 40%;
  @media (max-width: 1200px) {
    width: 100%;
    height: 40%;
  }
  @media (max-width: 900px) {
    height: 30%;
  }
`;
export const ContentRight = styled.div`
  width: 20%;
  height: 100%;
  @media (max-width: 1200px) {
    display: none;
  }
  @media (max-width: 900px) {
    height: 30%;
  }
`;

export const TradeRealTimeWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 900px) {
    height: 100%;
    margin-bottom: 10px;
  }
`;

export const FavouriteScrollWrapper = styled.div`
  position: relative;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme?.COLORS?.stroke};
`;

export const FavouriteScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px;
  width: 100%;
  padding-bottom: 6px;
  padding-top: 6px;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 8px;
  min-height: 50px;

  /* 스크롤바 완전 숨김 */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

export const ScrollButton = styled.button<{
  direction: 'left' | 'right';
  disabled?: boolean;
}>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ direction }) => (direction === 'left' ? 'left: 8px;' : 'right: 8px;')}

  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme?.COLORS?.stroke};
  background: ${({ theme }) => theme?.COLORS?.drawerBgColor || '#fff'};
  color: ${({ theme }) => theme?.COLORS?.textw};

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  z-index: 99;

  &:hover {
    ${({ disabled, theme }) =>
      !disabled &&
      `
      background: ${theme?.COLORS?.stroke};
      transform: translateY(-50%) scale(1.05);
    `}
  }

  &:active {
    ${({ disabled }) =>
      !disabled &&
      `
      transform: translateY(-50%) scale(0.95);
    `}
  }
`;
